module.exports = __webpack_public_path__ + "img/IMG_6984_L_Foamcore_MockedUp.acebe48b.jpg";